import { Component, OnInit, ViewChild } from '@angular/core';
import { RenewalContactInfo } from '../../models/renewal-contact-info';
import { Router } from '@angular/router';
import { RenewalCogService } from 'services/renewalcog.service';
import { RenewalVehicle } from '../../models/renewal-vehicle';
import { ErrorService } from '../../../services/error.service'
import { LabelValue } from 'app/models/labelvalue';

@Component({
  selector: 'app-contact-info-cog',
  templateUrl: './contact-info-cog.component.html',
  styleUrls: ['./contact-info-cog.component.css']
})
export class ContactInfoCogComponent implements OnInit {

  model: RenewalContactInfo;
  states: LabelValue[] = [];
  hasVehicleOptions: LabelValue[];
  residents: LabelValue[] = [];

  constructor(
    private renewalService: RenewalCogService, private errorService: ErrorService,
    public router: Router
  ) {
    this.model = new RenewalContactInfo();

    const RenewalKey = localStorage.getItem('RenewalKey');

    if (RenewalKey !== undefined && RenewalKey !== null) {
      this.model.LeaseRenewalKey = Number(RenewalKey);
      this.renewalService.getRenewalContactInfo(this.model)
        .subscribe(res => this.getRenewalContactInfo(res), err => this.errorService.showError(err));

    } else {
      this.errorService.showError("Error - unable to verify renewal key.");
    }

  }

  ngOnInit() {
    this.getStates();
    this.getHasVehicleOptions();

  }

  async getRenewalContactInfo(contactInfo: RenewalContactInfo) {
    this.model = contactInfo;
    this.getResidentOptions();
  }

  getResidentOptions() {
    this.residents = [];

    for (const res of this.model.Residents) {
      this.residents.push({ label: res.FullName, value: res.ResidentKey });
    }
  }

  getHasVehicleOptions() {
    this.hasVehicleOptions = [];
    this.hasVehicleOptions.push({ label: "Do you have any vehicles?", value: null })
    this.hasVehicleOptions.push({ label: "Yes", value: true });
    this.hasVehicleOptions.push({ label: "No", value: false });
  }

  getStates() {
    this.states.push({ label: 'Alabama', value: 'AL' });
    this.states.push({ label: 'Alaska', value: 'AK' });
    this.states.push({ label: 'Arizona', value: 'AZ' });
    this.states.push({ label: 'Arkansas', value: 'AR' });
    this.states.push({ label: 'California', value: 'CA' });
    this.states.push({ label: 'Colorado', value: 'CO' });
    this.states.push({ label: 'Connecticut', value: 'CT' });
    this.states.push({ label: 'Delaware', value: 'DE' });
    this.states.push({ label: 'Florida', value: 'FL' });
    this.states.push({ label: 'Georgia', value: 'GA' });

    this.states.push({ label: 'Hawaii', value: 'HI' });
    this.states.push({ label: 'Idaho', value: 'ID' });
    this.states.push({ label: 'Illinois', value: 'IL' });
    this.states.push({ label: 'Indiana', value: 'IN' });
    this.states.push({ label: 'Iowa', value: 'IA' });
    this.states.push({ label: 'Kansas', value: 'KS' });
    this.states.push({ label: 'Kentucky', value: 'KY' });
    this.states.push({ label: 'Louisiana', value: 'LA' });
    this.states.push({ label: 'Maine', value: 'ME' });
    this.states.push({ label: 'Maryland', value: 'MD' });

    this.states.push({ label: 'Massachusetts', value: 'MA' });
    this.states.push({ label: 'Michigan', value: 'MI' });
    this.states.push({ label: 'Minnesota', value: 'MN' });
    this.states.push({ label: 'Mississippi', value: 'MS' });
    this.states.push({ label: 'Missouri', value: 'MO' });
    this.states.push({ label: 'Montana', value: 'MT' });
    this.states.push({ label: 'Nebraska', value: 'NE' });
    this.states.push({ label: 'Nevada', value: 'NV' });
    this.states.push({ label: 'New Hampshire', value: 'NH' });
    this.states.push({ label: 'New Jersey', value: 'NJ' });

    this.states.push({ label: 'New Mexico', value: 'NM' });
    this.states.push({ label: 'New York', value: 'NY' });
    this.states.push({ label: 'North Carolina', value: 'NC' });
    this.states.push({ label: 'North Dakota', value: 'ND' });
    this.states.push({ label: 'Ohio', value: 'OH' });
    this.states.push({ label: 'Oklahoma', value: 'OK' });
    this.states.push({ label: 'Oregon', value: 'OR' });
    this.states.push({ label: 'Pennsylvania', value: 'PA' });
    this.states.push({ label: 'Rhode Island', value: 'RI' });
    this.states.push({ label: 'South Carolina', value: 'SC' });

    this.states.push({ label: 'South Dakota', value: 'SD' });
    this.states.push({ label: 'Tennessee', value: 'TN' });
    this.states.push({ label: 'Texas', value: 'TX' });
    this.states.push({ label: 'Utah', value: 'UT' });
    this.states.push({ label: 'Vermont', value: 'VT' });
    this.states.push({ label: 'Virginia', value: 'VA' });
    this.states.push({ label: 'Washington', value: 'WA' });
    this.states.push({ label: 'West Virginia', value: 'WV' });
    this.states.push({ label: 'Wisconsin', value: 'WI' });
    this.states.push({ label: 'Wyoming', value: 'WY' });
  }

  onRemoveVehicleClick(vehicle: RenewalVehicle) {
    if (this.model.HasVehicles && this.model.Vehicles.length == 1) {
      //
    }
    else {
      const index = this.model.Vehicles.indexOf(vehicle);
      this.model.Vehicles.splice(index, 1);
    }
  }

  forceAtLeastOneVehicle(ob) {
    if (this.model.HasVehicles) {
      if (this.model.Vehicles.length === 0) {
        this.model.Vehicles.push(new RenewalVehicle());
      }
    }
  }

  onAddVehicleClick() {
    this.model.Vehicles.push(new RenewalVehicle());
  }

  removeUnusedVehicles() {
    if (this.model.Vehicles.length === 1) {
      if (this.model.Vehicles[0].Year === '' && this.model.Vehicles[0].Make === '' && this.model.Vehicles[0].VehicleModel === '' && this.model.Vehicles[0].State === '' && this.model.Vehicles[0].Plate === '' && this.model.Vehicles[0].Color === '' && !this.model.Vehicles) {
        this.onRemoveVehicleClick(this.model.Vehicles[0]);
      }
    }

    this.onSubmit();
  }

  onSubmit() {
    if (!this.model.HasVehicles) {
      this.model.Vehicles = [];
    }
    this.renewalService.updateContactInfo(this.model)
      .subscribe(res => this.onUpdateSuccess(),
        err => this.errorService.showError(err));
  }

  onUpdateSuccess() {
    this.router.navigate(['/renewalcog/renewal-review/other-occupant']);
  }

  // Do Not Delete.  ngFor will break on add remove without.
  listTrack(o) {
    return o;
  }

}
